<template>
  <div class="cruise-search-tips" v-if="step">
    <div class="cruise-search-tips-bg"></div>
    <div class="step-1 step" v-show="step1">
        <img src="https://resource.rcclchina.com.cn/tui2/cruise/step1_filter.png" class="step1_filter" />
        <div class="tips-content">
            <div class="tips-content-text">
                <p>利用筛选工具便捷挑选心仪航线</p>
            </div>
            <div class="tips-content-next next" data-next="step-2" data-current="step-1" @click="stepOne">
                <img src="https://resource.rcclchina.com.cn/tui2/cruise/step_next.png" />
            </div>
            <div class="tip-content-skip skip" @click="closeFn">
                跳过>
            </div>
        </div>
    </div>
    <div class="step-2 step" v-show="step2">
        <img src="https://resource.rcclchina.com.cn/tui2/cruise/step1_wishlist.png" class="step2_wishlist" />
        <div class="tips-content">
            <div class="tips-content-text">
                <p>点这里收藏心仪航线</p>
            </div>
            <div class="tips-content-next next" data-next="step-3" data-current="step-2" @click="stepTwo">
                <img src="https://resource.rcclchina.com.cn/tui2/cruise/step_next.png" />
            </div>
            <div class="tip-content-skip skip" @click="closeFn">
                跳过>
            </div>
        </div>
    </div>
    <div class="step-3 step " v-show="step3">
        <img src="https://resource.rcclchina.com.cn/tui2/cruise/step3_calendar.png" class="step3_calendar" />
        <div class="tips-content">
            <div class="tips-content-text">
                <p>点这里查看同款航线所有出行日期</p>
            </div>
            <div class="tips-content-next next" data-next="step-4" data-current="step-3" @click="stepThree">
                <img src="https://resource.rcclchina.com.cn/tui2/cruise/step_next.png" />
            </div>
            <div class="tip-content-skip skip" @click="closeFn">
                跳过>
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
import Cookies from "js-cookie";
  export default {
    data(){
      return {
        step:false,
        step1:false,
        step2:false,
        step3:false,
      }
    },
    mounted(){
      const cookie = Cookies.get("cruisePortBannerStep");
      if(!cookie){
        this.step = true;
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
      }
      
    },
    methods:{
      closeFn(){
        this.step = false;
        this.step1 = false;
        this.step2 = false;
        this.step3 = false;
        Cookies.set('cruisePortBannerStep', '1', { expires: 1, path: '/' });
      },
      stepOne(){
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      },
      stepTwo(){
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
      },
      stepThree(){
        this.step1 = false;
        this.step2 = false;
        this.step3 = false;
        this.closeFn()
      },
    }
  }
</script>

<style lang="less" scoped>
.cruise-search-tips {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 50001;
    display: block;
}

.cruise-search-tips .step {
    position: relative;
    width: 100%;
    height: 100%;
}

.cruise-search-tips .cruise-search-tips-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(21, 22, 29, 0.7);
    
}

.cruise-search-tips .tips-content p {
    margin: 2px 0px;
}

.cruise-search-tips .tips-content-next {
    width: 100px;
    margin: 20px auto 0 auto;
}

.cruise-search-tips .tips-content-next img {
    width: 100%;
}

.cruise-search-tips .tip-content-skip {
    text-decoration: underline;
    margin-top: 12px;
}

.cruise-search-tips .tips-content {
    position: absolute;
    color: white;
    font-size: 15px;
    text-align: center;
}


.cruise-search-tips .step-1 .step1_filter {
    position: relative;
    width: 96.8%;
    left: 1.6%;
    top: 50px;
}

.cruise-search-tips .step-1 .tips-content {
    width: 66.4%;
    left: 16.8%;
    top: 130px;
    
}


.cruise-search-tips .step-2 .step2_wishlist {
    position: absolute;
    width: 38px;
    right: 14px;
    top: 176px;
}

.cruise-search-tips .step-2 .tips-content {
    right: 30px;
    top: 231.5px;
    
}

.cruise-search-tips .step-3 .step3_calendar {
    position: absolute;
    width: 38px;
    right: 62px;
    top: 218px;
}

.cruise-search-tips .step-3 .tips-content {
    right: 57px;
    top: 267.5px;
    
}

.cruise-search-tips .step-4 .tips-content {
    right: 41px;
    top: 355.5px;
    
}
</style>